import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatListOption } from '@angular/material/list';
import { SelectOption } from '@examdojo/core/util/select-option';
import { SelectionListComponent } from '@examdojo/ui/selection-list';

@Component({
  selector: 'dojo-assessment-type-selection',
  imports: [SelectionListComponent],
  templateUrl: './assessment-type-selection.component.html',
  styleUrl: './assessment-type-selection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssessmentTypeSelectionComponent {
  @Input({ required: true }) formCtrl!: FormControl;
  @Input({ required: true }) options: Array<SelectOption<unknown>> = [];
  @Output() optionSelected = new EventEmitter<MatListOption[]>();
}
